import { FC } from 'react';

interface Props {
  checked: boolean;
  onChange: (v: boolean) => void;
  disabled?: boolean;
  title?: string;
  description?: string;
  showDescription?: boolean;
  showSectionLabel?: boolean;
}

const CARD_CLASSES = [
  'tw-flex tw-items-center tw-gap-8 tw-w-full tw-text-left tw-appearance-none',
  'tw-rounded-[12px] tw-border-2 tw-border-solid tw-bg-white tw-p-3',
  'tw-border-neutral-200 tw-cursor-pointer',
  'hover:tw-border-[#9fabfd]',
  'focus-visible:tw-outline-none focus-visible:tw-border-indigo-600 focus-visible:tw-shadow-[0_0_0_3px_#c2c9fe]',
  'disabled:tw-border-neutral-100 disabled:tw-opacity-60 disabled:tw-cursor-not-allowed',
].join(' ');

export const BlockOtherUnitsSwitch: FC<Props> = ({
  checked,
  onChange,
  disabled = false,
  title = 'Block other units',
  description = "Students can only work in the focus Unit while it's on",
  showDescription = true,
  showSectionLabel = true,
}) => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-2 tw-w-full">
      {showSectionLabel && (
        <p className="tw-m-0 tw-pl-3 tw-font-atkinson tw-text-neutral-700">
          <span className="tw-font-bold tw-text-[14px] tw-leading-[20px]">Access to other units&nbsp;</span>
          <span className="tw-text-[12px] tw-leading-[16px]">optional</span>
        </p>
      )}

      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={title}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={CARD_CLASSES}
      >
        <span className="tw-flex tw-flex-1 tw-min-w-0 tw-flex-col tw-gap-1">
          <span
            className={`tw-font-atkinson tw-font-bold tw-text-[16px] tw-leading-[20px] tw-whitespace-nowrap ${
              checked ? 'tw-text-indigo-600' : 'tw-text-neutral-950'
            }`}
          >
            {title}
          </span>
          {showDescription && (
            <span className="tw-font-atkinson tw-text-[12px] tw-leading-[16px] tw-text-neutral-700">{description}</span>
          )}
        </span>

        <span
          aria-hidden="true"
          className={`tw-flex tw-h-[24px] tw-w-[44px] tw-shrink-0 tw-items-center tw-rounded-full tw-px-[2px] ${
            checked ? 'tw-justify-end tw-bg-[#0a41bd]' : 'tw-justify-start tw-bg-neutral-200'
          }`}
        >
          <span
            className={`tw-block tw-h-[20px] tw-w-[20px] tw-rounded-full tw-bg-white ${
              checked
                ? 'tw-shadow-[0_0_20px_0_rgba(132,123,111,0.15)]'
                : 'tw-shadow-[0_0_15px_0_rgba(132,123,111,0.15)]'
            }`}
          />
        </span>
      </button>
    </div>
  );
};
